// extracted by mini-css-extract-plugin
module.exports = {"LBHeader":"style_LBHeader__W7QRx","menuIcon":"style_menuIcon__ZxuKm"};